var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStickEventTitle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 76,
    viewBox: "0 0 269 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0978159 74.38V0.459995H51.1378V15.31H20.5578V29.39H44.4278V43.91H20.5578V59.53H52.1278V74.38H0.0978159ZM74.3538 74.38L54.3338 17.62H73.9138L84.9138 53.15H85.2438L96.2438 17.62H113.844L93.8238 74.38H74.3538ZM142.58 28.95C137.3 28.95 134.33 32.69 133.67 40.17H150.83C150.83 36.1367 150.17 33.2767 148.85 31.59C147.53 29.83 145.44 28.95 142.58 28.95ZM144.67 75.37C124.724 75.37 114.75 65.7633 114.75 46.55V45.12C114.75 36.3933 117.244 29.4633 122.23 24.33C127.29 19.1967 134.074 16.63 142.58 16.63C151.82 16.63 158.494 19.0867 162.6 24C166.707 28.9133 168.76 36.21 168.76 45.89V50.73H133.78C134.294 55.0567 135.797 58.0633 138.29 59.75C140.784 61.3633 144.524 62.17 149.51 62.17C155.084 62.17 160.73 61.0333 166.45 58.76V70.31C160.73 73.6833 153.47 75.37 144.67 75.37ZM173.569 74.27V17.62H191.609V22.57H192.159C197.219 18.61 203.232 16.63 210.199 16.63C221.345 16.63 226.919 21.8 226.919 32.14V74.27H208.219V37.31C208.219 35.0367 207.669 33.46 206.569 32.58C205.542 31.6267 203.709 31.15 201.069 31.15C198.355 31.15 195.459 31.7733 192.379 33.02V74.27H173.569ZM255.617 75.15C249.603 75.15 245.093 73.94 242.087 71.52C239.08 69.1 237.577 64.92 237.577 58.98V30.71H230.537V17.73H237.577V4.31H256.387V17.73H267.827V30.71H256.387V56.23C256.387 58.21 256.827 59.5667 257.707 60.3C258.66 61.0333 260.273 61.4 262.547 61.4C264.6 61.4 266.47 61.2167 268.157 60.85V72.95C265.077 74.4167 260.897 75.15 255.617 75.15Z",
    fill: "url(#paint0_linear_4498_1209)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4498_1209",
    x1: 132.5,
    y1: -4.75877,
    x2: 132.5,
    y2: 105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#021104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#071A08"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickEventTitle2);
export default __webpack_public_path__ + "static/media/stick-event-title2.d68abd43afe617044ab8407ff310a781.svg";
export { ForwardRef as ReactComponent };